var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id, validationId) {
      pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};


















































pug_mixins["checkbox"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
if (!attributes.attributes) {
attributes.attributes = {}
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "checkbox schema-form-checkbox"},attributes.groupAttributes]), true)) + "\u003E\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes([attributes.fieldHtmlClass], [true]),"type": "checkbox","ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"id": pug.escape(id),"name": pug.escape(id),"required": pug.escape(attributes.required),"ng-true-value": pug.escape(attributes['ng-true-value']),"ng-false-value": pug.escape(attributes['ng-false-value']),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E\u003Clabel" + (pug.attr("class", pug.classes([attributes.labelHtmlClass], [true]), false, true)+pug.attr("for", id, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E";
};




















































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};





























































pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}


































































pug_html = pug_html + "\u003Cdiv class=\"row car-checkout\"\u003E\u003Cdiv class=\"checkout-wrapper\"\u003E\u003Cdiv class=\"page-title-container\"\u003E\u003Ch1 class=\"page-title\"\u003EBeantragung – Schritt {{ $ctrl.step() }} von {{ $ctrl.steps() }}\u003C\u002Fh1\u003E\u003Cbr\u003E\u003Cbr\u003E\u003Cbr\u003E\u003Cdiv class=\"checkout-main\"\u003E\u003C\u002Fdiv\u003E\u003Cwizard on-finish=\"$ctrl.wizardFinished()\" on-cancel=\"$ctrl.wizardCanceled()\" hide-indicators=\"true\"\u003E\u003Cwz-step wz-title=\"Zusammenfassung\" edit-mode=\"true\"\u003E\u003Cdiv ng-if=\"$ctrl.loading\"\u003ELaden\u003C\u002Fdiv\u003E\u003Cdiv class=\"checkout_zusammenfassung-wrapper\" ng-if=\"!$ctrl.loading\"\u003E\u003Cdiv class=\"bigbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cspan\u003EDas kostet Sie das DeutschlandTicket JOB\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\" ng-if=\"$ctrl.hasActiveDTicket\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cp class=\"error\"\u003EDiese Wahlleistung wird von Ihnen bereits genutzt.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\" ng-if=\"!$ctrl.hasActiveDTicket\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv ng-if=\"$ctrl.checkoutInformation.employer_subsidy &gt; 0 &amp;&amp; $ctrl.checkoutInformation.discount === 0\"\u003E\u003Cp\u003ENormal belaufen sich die Kosten für das Deutschlandticket auf {{$ctrl.checkoutInformation.ticket_default_price | currency: 'EUR'}}. Ihr Arbeitgeber leistet einen Zuschuss von {{$ctrl.checkoutInformation.employer_subsidy | currency: 'EUR'}}.\n Damit beträgt der durch Sie zu übernehmende Anteil noch {{$ctrl.checkoutInformation.employee_contribution | currency: 'EUR'}}.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.checkoutInformation.employer_subsidy &gt; 0 &amp;&amp; $ctrl.checkoutInformation.discount &gt; 0\"\u003E\u003Cp\u003ENormal belaufen sich die Kosten für das Deutschlandticket auf {{$ctrl.checkoutInformation.ticket_default_price | currency: 'EUR'}}. Ihr Arbeitgeber leistet einen Zuschuss von {{$ctrl.checkoutInformation.employer_subsidy | currency: 'EUR'}}.\n Da Ihr Arbeitgeber mindestens 25 % auf den Ticketpreis bezuschusst, erhalten Sie zusätzlich einen Rabatt von 5 %.\n Damit beträgt der durch Sie zu übernehmende Anteil noch {{$ctrl.checkoutInformation.employee_contribution | currency: 'EUR'}}.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.checkoutInformation.employer_subsidy == 0\"\u003E\u003Cp\u003EDie Kosten für das Deutschlandticket belaufen sich auf {{$ctrl.checkoutInformation.ticket_default_price | currency: 'EUR'}}. Der durch Sie zu übernehmende Anteil beträgt {{$ctrl.checkoutInformation.employee_contribution | currency: 'EUR'}}.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.checkoutInformation.flat_tax_type === 'ag'\"\u003E\u003Cp\u003EIhren Eigenanteil wandeln Sie monatlich von Ihrem Entgelt um.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.checkoutInformation.flat_tax_type === 'an'\"\u003E\u003Cp\u003EIhren Eigenanteil wandeln Sie monatlich von Ihrem Entgelt um. Auf die Umwandlung fällt eine Pauschalsteuer in Höhe von 25 % an. Diese tragen Sie über die Entgeltabrechnung.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.checkoutInformation.flat_tax_type === 'no_tax'\"\u003E\u003Cp\u003EDer Eigenanteil wird monatlich über Ihr Netto vor Auszahlung auf Ihr Bankkonto einbehalten.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bigbox centered\"\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cbutton class=\"btn btn-primary left\" ng-click=\"$ctrl.navigateToDashboard()\"\u003EZurück\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"btn btn-primary right\" wz-next ng-disabled=\"$ctrl.hasActiveDTicket\"\u003EWeiter zu den Adressdaten\u003C\u002Fbutton\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003C\u002Fwz-step\u003E\u003Cwz-step class=\"address\" wz-title=\"Delivery Data\" edit-mode=\"true\"\u003E\u003Cdiv ng-if=\"$ctrl.loading\"\u003ELaden\u003C\u002Fdiv\u003E\u003Cdiv class=\"checkout_dokumente-wrapper\" ng-if=\"!$ctrl.loading\"\u003E\u003Cdiv class=\"bigbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cspan\u003EAdressdaten\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cstrong\u003EAdresse\u003C\u002Fstrong\u003EBitte überprüfen Sie die Angaben und geben hier Ihre aktuelle, korrekte Anschrift an. Sie muss Ihre aktuelle Meldeadresse widerspiegeln.\u003Cbr\u003EDiese ist unter anderem auch erforderlich, um Ihren Zusatz zum Arbeitsvertrag zu erzeugen.\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cbr\u003E\u003Cdiv class=\"columns\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.employeeAddress.street","title": "Straße","required": pug.escape(true),"data-cy": "neo.checkout.carLeasing.employeeData.inputEmployeeStreet","validationMessages": {"required":"Bitte geben Sie eine Straße ein."}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-6\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.employeeAddress.zip","title": "PLZ","required": pug.escape(true),"data-cy": "neo.checkout.carLeasing.employeeData.inputEmployeePostcode","validationMessages": {"required":"Bitte geben Sie eine Postleitzahl ein."}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-6\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.employeeAddress.city","title": "Ort","required": pug.escape(true),"data-cy": "neo.checkout.carLeasing.employeeData.inputEmployeeCity","validationMessages": {"required":"Bitte geben Sie einen Ort an."}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E";
},
attributes: {"class": "form-padding","name": "$ctrl.forms.EmployeeAddressForm"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bigbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cspan\u003EGeburtsdatum\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cstrong\u003EGeburtsdatum\u003C\u002Fstrong\u003EBitte überprüfen Sie Ihr Geburtsdatum. Dieses wird zur Legitimation benötigt.\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns\"\u003E\u003Cbr\u003E\u003Cdatepicker date-format=\"dd.MM.yyyy\" selector=\"birthdateInput\" date-refocus=\"true\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.employeeIntegrityData.geburtsdatum","required": pug.escape(true),"attributes": {"vn-date":"true","vn-date-reformat":"true","vn-date-string-model":"true","vn-date-year-range":"true","vn-date-age-min":14,"vn-date-age-max":90,"ng-model-options":"{allowInvalid: true}","ng-pattern":"\u002F^(0?[1-9]|[12][0-9]|3[01])\\.([0]?[0-9]|1[0-2])\\.\\d{4}$\u002F","tabindex":1},"fieldHtmlClass": "birthdateInput","validationMessages": {"required":"Bitte Geburtsdatum angeben","parse":"Bitte Geburtsdatum im Format tt.mm.jjjj eingeben","age":"Bitte überprüfen Sie die Eingabe"}}
});
pug_html = pug_html + "\u003C\u002Fdatepicker\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "$ctrl.employeeBirthdateForm"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bigbox centered\"\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cbutton class=\"btn btn-primary left\" wz-previous\u003EZurück\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-primary right\" ng-click=\"$ctrl.proceedToGDPR()\" ng-disabled=\"$ctrl.forms.EmployeeAddressForm.$invalid || $ctrl.employeeBirthdateForm.$invalid\"\u003EWeiter zur Datenverarbeitung\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003C\u002Fwz-step\u003E\u003Cwz-step wz-title=\"Additional GDPR\" edit-mode=\"true\"\u003E\u003Cdiv class=\"checkout_documente-wrapper\"\u003E\u003Cdiv class=\"bigbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cspan\u003EEinwilligung zur Datenverarbeitung\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cp\u003EDas Deutschlandticket ist nicht übertragbar. Daher müssen Ihre Identifikationsmerkmale an den Verkehrsbetrieb übermittelt werden. Diese Informationen werden auf dem elektronischen Abbild des Deutschlandtickets aufgedruckt sein und dienen zur Kontrolle.\u003C\u002Fp\u003E\u003Cp\u003EBitte bestätigen Sie, dass die Daten im Rahmen der Nutzung des Benefits DeutschlandTicket JOB an diese Dienstleister übermittelt werden.\u003C\u002Fp\u003E\u003Cdiv\u003E\u003Cstrong\u003Ezu übermittelnde Daten\u003C\u002Fstrong\u003E: Vorname, Name, Geburtsdatum\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv\u003E\u003Cstrong\u003EEmpfänger\u003C\u002Fstrong\u003E: Vesputi GmbH, Spinnereistraße 7, 04179 Leipzig\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Cstrong\u003EGrund der Übermittlung\u003C\u002Fstrong\u003E: Legitimation\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E";
pug_mixins["checkbox"].call({
attributes: {"key": "$ctrl.toc_accepted","title": "Ich bin mit der Übermittlung einverstanden.","labelHtmlClass": "switchbox-float-label","required": pug.escape(true)}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bigbox centered\"\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cbutton class=\"btn btn-primary left\" wz-previous\u003EZurück zu den Adressdaten\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-primary right\" ng-click=\"$ctrl.proceedToContractOverview()\" ng-disabled=\"$ctrl.toc_accepted != true\"\u003E{{$ctrl.toc_accepted ? 'Weiter zur Vertragsvorschau' : 'Bitte Datenschutz bestätigen' }}\u003C\u002Fbutton\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003C\u002Fwz-step\u003E\u003Cwz-step wz-title=\"Contract\" edit-mode=\"true\"\u003E\u003Cdiv class=\"checkout_dokumente-wrapper\"\u003E\u003Cdiv class=\"bigbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cspan\u003EVertragsvorschau\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cp\u003ESo wird der Zusatz zu Ihrem Arbeitsvertrag dann aussehen.\u003C\u002Fp\u003E\u003Cp ng-if=\"$ctrl.checkoutInformation.has_approval\"\u003ENach Freigabe Ihres Vertrags durch Ihren Arbeitgeber erhalten Sie die Aufforderung zur digitalen Unterzeichnung des Vertrags.\u003C\u002Fp\u003E\u003Cp ng-if=\"!$ctrl.checkoutInformation.has_approval\"\u003ENach Abschluss Ihrer Bestellung erhalten Sie die Aufforderung zur digitalen Unterzeichnung des Vertrags.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv ng-if=\"$ctrl.loading\"\u003ELaden\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.contract_url\"\u003E\u003Ccontract-preview contracturl=\"$ctrl.contract_url\" can-download=\"false\" ng-if=\"!$ctrl.loading\"\u003E\u003C\u002Fcontract-preview\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bigbox centered\"\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cbutton class=\"btn btn-primary left\" ng-disabled=\"$ctrl.loading\" wz-previous\u003EZurück\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-primary right\" ng-disabled=\"$ctrl.loading\" wz-next\u003EWeiter zur Zusammenfassung\u003C\u002Fbutton\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003C\u002Fwz-step\u003E\u003Cwz-step wz-title=\"Overview\" edit-mode=\"true\" canenter=\"!$ctrl.loading\"\u003E\u003Cdiv ng-if=\"$ctrl.loading\"\u003ELaden\u003C\u002Fdiv\u003E\u003Cdiv class=\"checkout_dokumente-wrapper\" overlay=\"$ctrl.loading\"\u003E\u003Cdiv class=\"bigbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cspan\u003EZusammenfassung\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\" ng-if=\"!$ctrl.isMobile\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"row basket-overview-checkout-wrapper\" overlay=\"$ctrl.loading\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12 side-effect\"\u003E\u003Cdiv class=\"side-scrollable\"\u003E\u003Ctable\u003E\u003Ctr\u003E\u003Cth\u003ETicketkosten\u003C\u002Fth\u003E\u003Cth\u003EArbeitgeber Anteil\u003C\u002Fth\u003E\u003Cth ng-if=\"$ctrl.checkoutInformation.discount &gt; 0\"\u003ERabatt\u003C\u002Fth\u003E\u003Cth ng-if=\"$ctrl.checkoutInformation.flat_tax_type == 'an'\"\u003EPauschalsteuer\u003C\u002Fth\u003E\u003Cth\u003E{{ $ctrl.checkoutInformation.flat_tax \u003E  0 ? 'Ihr Anteil durch Entgeltumwandlung' : 'Ihr Anteil durch Netto-Abzug'}}\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E{{ $ctrl.ticketDefaultPrice | currency: 'EUR'}}\u003C\u002Ftd\u003E\u003Ctd\u003E{{$ctrl.checkoutInformation.employer_subsidy | currency: 'EUR'}}\u003C\u002Ftd\u003E\u003Ctd ng-if=\"$ctrl.checkoutInformation.discount &gt; 0\"\u003E{{$ctrl.checkoutInformation.discount | currency: 'EUR'}}\u003C\u002Ftd\u003E\u003Ctd ng-if=\"$ctrl.checkoutInformation.flat_tax_type == 'an'\"\u003E{{$ctrl.checkoutInformation.flat_tax | currency: 'EUR'}}\u003C\u002Ftd\u003E\u003Ctd\u003E{{$ctrl.checkoutInformation.employee_contribution | currency: 'EUR'}}\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\" ng-if=\"$ctrl.isMobile\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cp\u003E\u003Cspan class=\"bold\"\u003ETicketkosten:&nbsp\u003C\u002Fspan\u003E\u003Cspan\u003E{{ $ctrl.ticketDefaultPrice | currency: 'EUR'}}\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cp\u003E\u003Cspan class=\"bold\"\u003EArbeitgeber Anteil:&nbsp\u003C\u002Fspan\u003E\u003Cspan\u003E{{$ctrl.checkoutInformation.employer_subsidy | currency: 'EUR'}}\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-12\" ng-if=\"$ctrl.checkoutInformation.discount &gt; 0\"\u003E\u003Cp\u003E\u003Cspan class=\"bold\"\u003ERabatt:&nbsp\u003C\u002Fspan\u003E\u003Cspan\u003E{{$ctrl.checkoutInformation.discount | currency: 'EUR'}}\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-12\" ng-if=\"$ctrl.checkoutInformation.flat_tax_type == 'an'\"\u003E\u003Cp\u003E\u003Cspan class=\"bold\"\u003EPauschalsteuer:&nbsp\u003C\u002Fspan\u003E\u003Cspan\u003E{{$ctrl.checkoutInformation.flat_tax | currency: 'EUR'}}\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cp\u003E\u003Cspan class=\"bold\"\u003E{{ $ctrl.checkoutInformation.flat_tax \u003E 0 ? 'Ihr Anteil durch Entgeltumwandlung' : 'Ihr Anteil durch Netto-Abzug' }}:&nbsp\u003C\u002Fspan\u003E\u003Cspan\u003E{{$ctrl.checkoutInformation.employee_contribution | currency: 'EUR'}}\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bigbox centered\"\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cbutton class=\"btn btn-primary left\" wz-previous\u003EZurück\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-primary right\" wz-next ng-disabled=\"$ctrl.loading || $ctrl.hasActiveDTicket\"\u003E\u003Cspan\u003EBestellung verbindlich ausführen\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003C\u002Fwz-step\u003E\u003C\u002Fwizard\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;